<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useTagEditor } from '@/composables/useTagEditor'

// What to do with the todos that still have the old name of a tag that is being renamed (`useTagEditor().renaming`).
const { t } = useI18n()
const { renaming, renameMode, renameProgress, saving, confirmRename } = useTagEditor()
</script>

<template>
  <div v-if="renaming" class="ui-backdrop" @click.self="!saving && (renaming = null)">
    <div class="ui-sheet" role="dialog" aria-modal="true">
      <h4>{{ t('settings.tags.rename.title') }}</h4>
      <p>
        <i18n-t keypath="settings.tags.rename.intro" tag="span">
          <template #old
            ><strong>{{ renaming.tag.name }}</strong></template
          >
          <template #new
            ><strong>{{ renaming.name }}</strong></template
          >
        </i18n-t>
      </p>
      <label class="choice">
        <input v-model="renameMode" type="radio" value="alias" />
        <i18n-t keypath="settings.tags.rename.alias" tag="span">
          <template #old
            ><strong>{{ renaming.tag.name }}</strong></template
          >
          <template #new
            ><strong>{{ renaming.name }}</strong></template
          >
        </i18n-t>
        <span class="ui-chip ui-chip-accent">{{ t('settings.tags.rename.recommended') }}</span>
      </label>
      <label class="choice">
        <input v-model="renameMode" type="radio" value="migrate" />
        <i18n-t keypath="settings.tags.rename.migrate" tag="span">
          <template #old
            ><strong>{{ renaming.tag.name }}</strong></template
          >
          <template #new
            ><strong>{{ renaming.name }}</strong></template
          >
        </i18n-t>
      </label>
      <label class="choice">
        <input v-model="renameMode" type="radio" value="none" />
        <span>{{ t('settings.tags.rename.none') }}</span>
        <span class="ui-chip ui-chip-danger">{{ t('settings.tags.rename.notRecommended') }}</span>
      </label>
      <div v-if="renameProgress" class="progress" role="status">
        <progress :value="renameProgress.done" :max="renameProgress.total || undefined"></progress>
        <span>{{ t('settings.tags.rename.progress', renameProgress) }}</span>
      </div>
      <div class="dialog-actions">
        <button type="button" :disabled="saving" @click="confirmRename">
          {{ t('settings.tags.rename.confirm') }}
        </button>
        <button type="button" class="secondary" :disabled="saving" @click="renaming = null">
          {{ t('common.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.choice {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.4rem 0;
}

.choice input {
  width: auto;
}

.progress {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0.5rem 0;
}

.progress progress {
  width: 100%;
}

.dialog-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
</style>
